var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSettings({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.335 0a1.84 1.84 0 011.84 1.84v.615c.528.167 1.043.372 1.54.613l.437-.417a1.84 1.84 0 012.601 0l2.602 2.602a1.84 1.84 0 010 2.602l-.423.423c.241.498.446 1.013.613 1.54h.614A1.84 1.84 0 0127 11.665v3.682a1.84 1.84 0 01-1.84 1.84h-.615a11.475 11.475 0 01-.613 1.541l.423.424a1.84 1.84 0 010 2.601l-2.602 2.602a1.84 1.84 0 01-2.601 0l-.424-.423c-.498.241-1.013.446-1.54.613v.614A1.84 1.84 0 0115.347 27h-3.682a1.84 1.84 0 01-1.84-1.84v-.615a11.481 11.481 0 01-1.54-.613l-.437.41a1.84 1.84 0 01-2.601 0l-2.602-2.6a1.84 1.84 0 010-2.603l.423-.423a11.475 11.475 0 01-.613-1.54H1.84A1.84 1.84 0 010 15.335v-3.682a1.84 1.84 0 011.84-1.841h.615c.167-.527.372-1.042.613-1.54l-.423-.424a1.84 1.84 0 010-2.601l2.602-2.602a1.84 1.84 0 012.601 0l.424.423a11.481 11.481 0 011.54-.613V1.84A1.84 1.84 0 0111.652 0zm.012 1.84h-3.682v2.007A9.763 9.763 0 007.983 5.37L6.56 3.946 3.958 6.547l1.424 1.424a9.763 9.763 0 00-1.522 3.682H1.84v3.682h2.007a9.763 9.763 0 001.522 3.682L3.946 20.44l2.601 2.602 1.424-1.424a9.757 9.757 0 003.682 1.522v2.02h3.682v-2.014a9.757 9.757 0 003.682-1.521l1.423 1.423 2.602-2.602-1.424-1.423a9.763 9.763 0 001.522-3.682h2.02v-3.682h-2.02a9.763 9.763 0 00-1.522-3.682l1.436-1.417-2.602-2.602-1.423 1.424a9.763 9.763 0 00-3.682-1.522V1.84zM13.5 8.59a4.91 4.91 0 110 9.82 4.91 4.91 0 010-9.82zm0 1.842a3.068 3.068 0 100 6.136 3.068 3.068 0 000-6.136z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.79dd7ceb.svg";
export { ForwardRef as ReactComponent };